/** 只允许站内相对路径，避免 login?from= 被拿去外跳。 */
export function safeInternalPath(raw: unknown, fallback = '/'): string {
  if (typeof raw !== 'string' || raw.length === 0) return fallback
  if (!raw.startsWith('/') || raw.startsWith('//') || raw.startsWith('/\\')) return fallback
  if (raw.includes('\\') || raw.includes('://')) return fallback
  if (raw === '/login' || raw.startsWith('/login?') || raw.startsWith('/login#')) return fallback
  return raw
}
